export const tooltipStylesAsClassName =
  'bg-gray-dark rounded-sm text-white min-w-[70px] z-[1005] shadow-[0px_4px_16px_rgba(0,0,0,0.1)]';

export const tooltipContentStylesAsClassName =
  'p-2 text-xs font-normal leading-4 text-center';
